import { firestoreService } from '../services/firestoreService';

/**
 * Get customer information from Firestore
 * @param {string} customerId - The Stripe customer ID
 * @returns {Promise<Object>} - A promise that resolves to the customer information
 */
export async function getCustomerInfo(customerId) {
    return await firestoreService.getDocument('donors', customerId);
}